import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"

const Header = ({ title, href }) => (
  <header className="header">
    <Link to={href} className="back-button">
      <svg className="back-icon" width="24" height="24" fill="#fff" viewBox="0 0 24 24">
        <path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"></path>
      </svg>
      <div>{ title }</div>
    </Link>
    <div className="header-title"></div>
    <div>
      <svg width="24" height="24" fill="#fff" viewBox="0 0 24 24">
        <path fill="none" d="M0 0h24v24H0z"></path>
        <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path>
      </svg>
    </div>
  </header>
)
      // <div>{ title }</div>

Header.propTypes = {
  title: PropTypes.string,
  href: PropTypes.string,
}

Header.defaultProps = {
  title: ``,
  href: ``,
}

export default Header
